import { css, type SerializedStyles } from '@emotion/react';

export function HOVER(
  template: TemplateStringsArray,
  ...args: Parameters<typeof css>[number][]
): SerializedStyles {
  return css`
    &.focus-visible:focus {
      ${css(template, ...args)}
    }
    @media(hover: hover) and (pointer: fine) {
      &:hover, &:active {
        ${css(template, ...args)}
      }
    }
  `;
}
